import React from 'react';
import { SearchIcon } from 'lucide-react';
export function Off1() {
  const buildRedirectUrl = () => {
    const baseUrl = 'https://go.trkrgodom.com/go/e770986e-48e4-49a8-a67c-5ca5e2dc32fc';
    const trafficSource = localStorage.getItem('ts') || 'TrafficSource';
    const domain = localStorage.getItem('targetingdomainid') || 'Domain';
    const keyword = localStorage.getItem('keywordid') || 'Keyword';
    return `${baseUrl}?TrafficSource=${trafficSource}&Domain=${domain}&Keyword=${keyword}`;
  };
  const handleCheckScore = () => {
    // Open in new tab
    window.open('https://go.trkrgodom.com/click', '_blank');
    // Navigate  in same tab
    window.location.href = buildRedirectUrl();
  };
  const handleSkip = () => {
    // Navigate to off2
    window.location.href = buildRedirectUrl();
  };
  return <div className="w-full min-h-screen font-['Open_Sans'] bg-gradient-to-br from-[#e3f2fd] to-[#f3e5f5]" data-id="element-165">
      <style data-id="element-166">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&family=Open+Sans:wght@400;600;400italic&display=swap');
          .cta-button {
            transition: all 0.3s ease;
          }
          .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
          }
          .skip-link {
            transition: all 0.2s ease;
          }
          .skip-link:hover {
            opacity: 0.8;
          }
        `}
      </style>

      <div className="px-4 py-6 min-h-screen flex flex-col items-center justify-center" data-id="element-167">
        <div className="max-w-3xl mx-auto text-center" data-id="element-168">
          {/* Logo */}

          {/* Main Headline */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-['Montserrat'] font-bold text-[#002E6D] mb-6 leading-tight" data-id="element-169">
            Since you want to boost your credit score…
          </h1>
          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-[#2E2E2E] mb-10 max-w-2xl mx-auto leading-relaxed italic font-light" data-id="element-170">
            Your best next step is to check your detailed credit report and
            score instantly.
          </p>
          {/* Image below subheadline */}
          <div className="mb-10" data-id="element-171">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a3bdA5CqLv2ZBGawr2gamX/67b51d0080b4dc855db3529e_creditscoreiq-logo.png" alt="Credit Score IQ" className="h-16 md:h-20 mx-auto" data-id="element-172" />
          </div>
          {/* Info Card */}
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 mb-8" data-id="element-173">
            <p className="text-xl text-[#2E2E2E] mb-8 leading-relaxed" data-id="element-174">
              Click "See My Score" below to be transferred to our trusted
              partner's site, where you can safely check your score and get
              personalized insights to improve it.
            </p>
            {/* CTA Button */}
            <button onClick={handleCheckScore} className="cta-button inline-flex items-center gap-3 bg-[#0039a6] text-white text-lg md:text-xl font-semibold px-10 py-5 rounded-xl hover:bg-[#002d80] shadow-lg mb-6" data-id="element-175">
              <SearchIcon className="w-6 h-6" data-id="element-176" />
              See My Score Now
            </button>
            {/* Skip Link */}
            <div data-id="element-177">
              <button onClick={handleSkip} className="skip-link text-sm text-gray-500 hover:text-gray-700 underline" data-id="element-178">
                No thanks, I'll check later.
              </button>
            </div>
          </div>
          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-6 text-gray-700 text-sm" data-id="element-179">
            <div className="flex items-center gap-2" data-id="element-180">
              <span data-id="element-181">🔒</span>
              <span data-id="element-182">100% Secure</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-183">
              <span data-id="element-184">✓</span>
              <span data-id="element-185">Trusted Partner</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-186">
              <span data-id="element-187">🎯</span>
              <span data-id="element-188">Free Credit Check</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}